import React from "react";
import styled from "styled-components";
import { CopyButton } from "../CopyButton/CopyButton";

export const TokenCell = ({ token, copyText, copiedText }) => {
  return (
    <Container>
      <TokenText>{token}</TokenText>
      <CopyButton value={token} copyText={copyText} copiedText={copiedText} />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  justify-content: center;
  flex-direction: column;
  width: 100px;
  margin: auto;
`;

const TokenText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: monospace;
`;
